<template>
  <v-row>
    <v-dialog v-model="attivo" persistent>
      <v-form
        ref="form"
        @submit.prevent="onSubmit"
        v-model="valid"
        lazy-validation
      >
        <v-card>
          <v-card-title>
            <span class="text-h5">
              <!--{{corsi_selezionati}}{{ limiteCorsi }}-->{{
                $t("corsi.titolo")
              }}</span
            >
          </v-card-title>
          <v-card-text>
            <stepperCorsi
              ref="childStepper"
              @validazione="validazione"
            ></stepperCorsi>
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <!--<v-btn color="primary darken-1" @click="validazione">
              Conferma
            </v-btn>-->
            <v-btn color="primary darken-1" text @click="chiudi">
              {{ $t("chiudi") }}
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-form>
    </v-dialog>
  </v-row>
</template>

<script>
import stepperCorsi from "@/components/sceltacorsi/stepper.vue";
import api from "@/services/EventService.js";
export default {
  name: "corsi",

  components: { stepperCorsi },

  props: {
    attivo: {
      default: false,
      type: Boolean,
    },
  },
  data: () => ({
    dialog: true,
  }),
  methods: {
    async chiudi() {
      //if (!this.$refs.form.validate()) {
      if (
        this.TotCorsi < this.limiteCorsi.corsi.min ||
        this.TotSeminari < this.limiteCorsi.seminari.min ||
        this.TotLetture < this.limiteCorsi.letture.min
      ) {
        await this.$store.dispatch("setStepNoCompletoEvent", 6);
      }
      this.attivo = false;
    },
    caricaLimiti() {
      api
        .get(
          "/anagrafiche/limiticorsi/" +
            this.iscrizione_store.dati.spec_scelta.CODICENU +
            "/" +
            this.iscrizione_store.dati.anno_scelto +
            "/" +
            this.parametri.semestre
        )
        //.then((file)=> this.pdfSource='data:application/pdf;base64,'+file+'')
        .then((risultato) => this.impostaLimite(risultato.data))
        .catch((error) => alert("Err:" + error));
    },

    impostaLimite(risultato) {
      try {
        this.limiteCorsi.corsi = risultato.corsi[0];
      } catch {
        (this.limiteCorsi.corsi.min = 0), (this.limiteCorsi.corsi.max = 999);
      }

      try {
        this.limiteCorsi.seminari = risultato.seminari[0];
      } catch {
        (this.limiteCorsi.seminari.min = 0),
          (this.limiteCorsi.seminari.max = 999);
      }

      try {
        this.limiteCorsi.letture = risultato.letture[0];
      } catch {
        (this.limiteCorsi.letture.min = 0),
          (this.limiteCorsi.letture.max = 999);
      }
    },
    async validazione() {
      //alert(this.TotCorsi+"@"+this.limiteCorsi.corsi.min)
      let flag = true;

      // se ospite, deve scegliere almeno un corso della Facoltà a cui vuole iscriversi
      //let corsolaurea = this.iscrizione_store.dati.ciclo_scelto.CODICENU;
      //let facolta_scelta = this.iscrizione_store.dati.fac_scelta.CODICENU;
      //let facolta_desc = this.iscrizione_store.dati.fac_scelta.DECODIF;
      //var checkCorsiOspite = this.corsi_selezionati.find(
      //(h) => h.FACOLTA == facolta_scelta
      //);

      /*if (!checkCorsiOspite && corsolaurea == 999) {
        flag = false;
        this.$swal
          .fire({
            confirmButtonClass: "btn-action darken-2 white--text btn",

            title: this.$t("corsi.corsiOspitiFuoriFacolta", {
              facolta: facolta_desc,
            }),
            icon: "error",
            showCancelButton: false,
            confirmButtonText: "OK",
            cancelButtonText: this.$t("salvaDati.btnAnnulla"),
          })
          .then(() => {
            this.$refs.childStepper.goStep(1);
          });
      }*/

      // verifica numero corsi rispetto ai parametri

      if (this.TotCorsi < this.limiteCorsi.corsi.min) {
        flag = false;
        this.$swal
          .fire({
            confirmButtonClass: "btn-action darken-2 white--text btn",

            title: this.$t("corsi.noScelta", {
              minCorsi: this.limiteCorsi.corsi.min,
            }),
            icon: "error",
            showCancelButton: false,
            confirmButtonText: "OK",
            cancelButtonText: this.$t("salvaDati.btnAnnulla"),
          })
          .then(() => {
            this.$refs.childStepper.goStep(1);
          });
      }

      if (this.TotCorsi > this.limiteCorsi.corsi.max) {
        flag = false;
        this.$swal
          .fire({
            confirmButtonClass: "btn-action darken-2 white--text btn",

            title: this.$t("corsi.troppiCorsi", {
              maxCorsi: this.limiteCorsi.corsi.max,
            }),
            icon: "error",
            showCancelButton: false,
            confirmButtonText: "OK",
            cancelButtonText: this.$t("salvaDati.btnAnnulla"),
          })
          .then(() => {});
      }

      // verifica numero seminari rispetto ai parametri
      if (
        this.TotSeminari < this.limiteCorsi.seminari.min &&
        this.parametri.statoSeminariLetture
      ) {
        flag = false;
        this.$swal
          .fire({
            confirmButtonClass: "btn-action darken-2 white--text btn",

            title: this.$t("corsi.noSceltaSeminari", {
              minCorsi: this.limiteCorsi.seminari.min,
            }),
            icon: "error",
            showCancelButton: false,
            confirmButtonText: "OK",
            cancelButtonText: this.$t("salvaDati.btnAnnulla"),
          })
          .then(() => {
            this.$refs.childStepper.goStep(2);
          });
      }

      if (this.TotSeminari > this.limiteCorsi.seminari.max) {
        flag = false;
        this.$swal
          .fire({
            confirmButtonClass: "btn-action darken-2 white--text btn",

            title: this.$t("corsi.troppiSeminari", {
              maxCorsi: this.limiteCorsi.seminari.max,
            }),
            icon: "error",
            showCancelButton: false,
            confirmButtonText: "OK",
            cancelButtonText: this.$t("salvaDati.btnAnnulla"),
          })
          .then(() => {});
      }

      // verifica numero letture rispetto ai parametri
      if (
        this.TotLetture < this.limiteCorsi.letture.min &&
        this.parametri.statoSeminariLetture
      ) {
        flag = false;
        this.$swal
          .fire({
            confirmButtonClass: "btn-action darken-2 white--text btn",

            title: this.$t("corsi.noSceltaLetture", {
              minCorsi: this.limiteCorsi.letture.min,
            }),
            icon: "error",
            showCancelButton: false,
            confirmButtonText: "OK",
            cancelButtonText: this.$t("salvaDati.btnAnnulla"),
          })
          .then(() => {
            this.$refs.childStepper.goStep(3);
            flag = false;
          });
      }

      if (this.TotLetture > this.limiteCorsi.letture.max) {
        flag = false;
        this.$swal
          .fire({
            confirmButtonClass: "btn-action darken-2 white--text btn",

            title: this.$t("corsi.troppiLetture", {
              maxCorsi: this.limiteCorsi.letture.max,
            }),
            icon: "error",
            showCancelButton: false,
            confirmButtonText: "OK",
            cancelButtonText: this.$t("salvaDati.btnAnnulla"),
          })
          .then(() => {});
      }

      // se tutto ok imposto lo step a completato
      if (flag) {
        await this.$store.dispatch("setStepCompletoEvent", 6);
        this.attivo = false;
      } else {
        await this.$store.dispatch("setStepNoCompletoEvent", 6);
      }

      //
    },
  },
  computed: {
    corsi_selezionati() {
      return this.$store.state.corsiscelti.corsi;
    },
    parametri() {
      return this.$store.state.parametri;
    },
    iscrizione_store() {
      return this.$store.state.iscrizione;
    },
    TotCorsi() {
      return this.$store.getters.totaleCorsiScelti;
    },
    TotSeminari() {
      return this.$store.getters.totaleSeminariScelti;
    },
    TotLetture() {
      return this.$store.getters.totaleLettureScelti;
    },
    limiteCorsi() {
      return this.$store.state.corsiscelti.limiti;
    },
  },
  activated() {
    // chiamo la funzione di carico deii valori limite (min e max) per la scelta dei corsi,seminari e letture
    this.caricaLimiti();
  },

  mounted() {
    this.caricaLimiti();
  },
};
</script>
